import React, { use, useContext, useEffect, useState } from 'react'
import { PageContext, ToastContext, UserContext } from "../App";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { TitleAtom } from "../atoms/titleAtom";
import { IconButton, ModalButton, StandardButton } from "../atoms/buttons";
import { TitleDescription } from "../components/titleDescription";
import { Alert } from "../components/alert";
import { InputForm, TextAreaForm } from "../atoms/input";
import { getAPI, postAPI, updateAPI } from "../api/api";
import { margin } from "polished";
import { ScoreOverviewModal } from "../components/customModals";
import { Spinner } from "../atoms/spinner";
import { he } from "date-fns/locale";

export default function CourseInfo({ loadCourse, courseData}) {
    const [activeContent, setActiveContent] = useState(2);
    const [aiLoading, setAiLoading] = useState(false);
    const [aiReload, setAiReload] = useState(false);
    const [course, setCourse] = useState({
        title: courseData.title,
        description: courseData.description,
        extra_description: courseData.extra_description
    })
    // const [courseName, setCourseName] = useState(courseData.title);
    // const [courseDescription, setCourseDescription] = useState(courseData.description);
    // const [courseExtraDescription, setCourseExtraDescription] = useState(courseData.extra_description);
    console.log("course", course)
    const toastContext = useContext(ToastContext);
    const [scoreModalVisible, setScoreModalVisible] = useState(false);
    const [exercises, setExercises] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorScoreMessage, setErrorScoreMessage] = useState("");
    const navigationContext = useContext(PageContext)
    const courseId = navigationContext.sidebar.courseID;
    const userId = navigationContext.sidebar.userId  
    const [showUnsavedModal, setShowUnsavedModal] = useState(false);
    const [quizStructure, setCourseStructure] = useState([])
    const loadAssessmentOverview = async () => {
          setLoading(true)
          let query = `api/assessments/overview?course=${courseId}&user=${userId === 0 ? "@me":userId}`
          const load = await getAPI(query)
          console.log("data is:",load.data," and id:",userId)
          console.log("res: ",load)
          if (!load?.data || load.data.length < 1 || load.status !== "ok") {
              setErrorScoreMessage((userId === 0 || userId === "@me") ? "Er is nog geen score-overzicht beschikbaar voor jouw, begin met leren." : "Deze gebruiker heeft nog geen score-overzicht.")  
              setExercises([]);
          }       
          else{
              setErrorScoreMessage("")
              setExercises(load.data)
          }
          setLoading(false)
              
      }
      
    const loadCurrentCourseStucture = async () => {
        setLoading(true);
        const userId = navigationContext.sidebar.userId === 0 ? "@me" : navigationContext.sidebar.userId;
        const query = `api/courses/lessons/${courseId}/structure?user=${userId}`;
    
        const load = await getAPI(query);
        console.log("loaddata",load)
       if (load?.data && load.data.length > 0 && load.status === "ok") {
        const updatedStructure = load.data.map((row) => ({
            ...row,
            collapsed: false,
        }));
        setCourseStructure(updatedStructure);
        setLoading(false);
        return;
        }
        setCourseStructure([]);
        setLoading(false);
    };
    
    useEffect(() => {
        if (
            courseData.title !== course.title ||
            courseData.description !== course.description ||
            courseData.extra_description !== course.extra_description
        ) {
            setCourse({
                title: courseData.title,
                description: courseData.description,
                extra_description: courseData.extra_description
            });
        }
    }, [courseData]);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth < 768;
    useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    useEffect(() => {
        loadAssessmentOverview()
        loadCurrentCourseStucture()
    }, [])
    
    const handleEditCourse = async () => {
        if (!course.title.trim() || !course.description.trim()) {
            toastContext.showToast(<>De titel en beschrijving mogen niet leeg zijn.</>, "error", 2000);
            return;
        }
        const query = "api/courses/edit";
        const body = { id_course: courseData.id_course, title: course.title, description: course.description, extra_description: course.extra_description };
        const response = await postAPI(query, body);

        if (response.status === "ok") {
            toastContext.showToast(<>Cursus is succesvol bijgewerkt!</>,"success", 1500);
            await loadCourse()
            setActiveContent(2); 
        } else {
            toastContext.showToast(<>Er is iets misgegaan bij het bijwerken van de cursus. Probeer het later opnieuw.</>, "error", 2000);
        }
    };
    const handleAiDescription = async () => {
        setAiLoading(true);
        const query = "api/courses/generate/description"
        console.log("data", courseData)
        const res = await postAPI(query, courseData);
        console.log("res", res)
        if (res.status === "ok"){
            setAiReload(true)
            toastContext.showToast(<>AI-beschrijving succesvol gegenereerd!</>, "success", 1500);
            await loadCourse()
        }
        setAiLoading(false);
    }
  const validateLessons = () => {
    const emptyLessons = quizStructure.filter(lesson => 
      !lesson.title || 
      !lesson.description || 
      !lesson.module_content || 
      lesson.module_content.trim() === ""
  );

  if (emptyLessons.length === 0) {
      console.log('error')
      return false; 
  }
  return true;
  };
    const publishLesson = async () => {
        if (!validateLessons()) {
            return;
        }
        const courseId = navigationContext.sidebar.courseID
        const query = "api/courses/publish"
        const body = {}
        body["id_course"] = courseId
        body["image_url"] = courseData?.image_url
        await updateAPI(query, body)
        navigationContext.handleNavigation({ courseID: 0, navigation: 2, enrollment: 0 })
        }
        const startCourse = async () => {
        const query = "api/assessments/start-assessment"
        const body = {}
        const courseId = navigationContext.sidebar.courseID
        body["id_course"] = courseId

        const post = await postAPI(query, body)
        if (post.status === "ok") {
            navigationContext.handleNavigation({ courseID: courseId, navigation: 10, enrollment: post.data })
        }
    }

  if (loading) {
    return <VerticalPageLayout style={{ justifyContent: "center", }}><Spinner size="5rem" thickness="2px" color="primary-600" /></VerticalPageLayout>;
  }
   
    return (
        <>
        <VerticalLayout className={`vertical phone-publish card-background-color ${courseData?.published === 2 ? "inactive" : ""}`} style={{ width: "100%", minHeight: isMobile && "calc(40rem - 4rem)" }}>
            <RenderContent course={course} setCourse={setCourse} activeContent={activeContent} handleEditCourse={handleEditCourse} handleAiDescription={handleAiDescription} aiLoading={aiLoading} aiReload={aiReload} loading={loading} startCourse={startCourse} publishLesson={publishLesson} setScoreModalVisible={setScoreModalVisible} setActiveContent={setActiveContent} courseData={courseData} />
        </VerticalLayout>
        <ScoreOverviewModal exercises={exercises} published={true} visible={scoreModalVisible} onDismiss={() => setScoreModalVisible(false)} />
        </>

    );
}
const RenderContent = ({activeContent, handleEditCourse, handleAiDescription, aiLoading, aiReload, loading, startCourse, publishLesson, setScoreModalVisible, setActiveContent, courseData, setCourse, course }) => {
    switch (activeContent) {
        case 1:
            return (
                <EditCourseContent
                    course={course}
                    setCourse={setCourse}
                    handleEditCourse={handleEditCourse}
                    dismiss={() => setActiveContent(2)}
                    handleAiGenerate={handleAiDescription}
                    aiLoading={aiLoading}
                    aiReload={aiReload}
                />
            );
        case 2:
            return (
                <InfoContent
                    editing={activeContent === 1}
                    courseData={courseData}
                    loading={loading}
                    startCourse={startCourse}
                    publishLesson={publishLesson}
                    setScoreModalVisible={setScoreModalVisible}
                    setActiveContent={setActiveContent}
                />
            );
            default: return <></>
    
    }
};
const InfoContent = ({ loading, startCourse, publishLesson, editing, courseData, setScoreModalVisible, setActiveContent }) => {
    const difficulty = () => {
        console.log("courseData difficulty", courseData?.difficulty);
        switch (courseData?.difficulty) {
            case 1 : return "Makkelijk"
            case 2 : return "Gemiddeld"
            case 3 : return "Moeilijk"
            default: return <></>
        }


    }
    const INFO_ITEMS = (courseData) => [
        { title: "Moeilijkheidsgraad", description: difficulty(), icon: "brain" },
        { title: "Tijdsduur", description: courseData?.duration , icon: "hourglass-2"},
        { title: "Aantal Lessen", description: courseData?.lessonCount , icon: "book-shelf"},
        { title: "Video", description: `${courseData?.videoCount || "Geen"} ${courseData?.videoCount === 1 ? "Video" : "Videos"}`, icon: "video-small-2"},
        { title: "Taal", description: courseData?.language , icon: "school" },
    ];

    const navigationContext = useContext(PageContext);
    const CourseDone = courseData.is_finished === 1;
    console.log("courseData", courseData)
    return (
        <>
            <VerticalLayout className="phone-publish-content standard-margin-bottom" style={{ height: "unset", width: "auto" }}>
                <TitleAtom className={"title-atom standard-margin"} title={"Cursus inhoud"} />
                <VerticalLayout style={{margin: "0 1rem", gap: ".45rem", width: "auto", }}>
                    {INFO_ITEMS(courseData).map((item, index) => (
                        <TitleDescription
                            icon2={item.icon}
                            key={index}
                            className={"info-items"}
                            style={{ margin: "0", gap: ".6rem", fontSize: "2rem" }}
                            title={item.title}
                            description={item.description}
                        />
                    ))}
                </VerticalLayout>
            </VerticalLayout>
            <HorizontalLayout className="space-between" style={{ gap: "1rem", marginTop: "auto", width: "auto", marginBottom:"1rem", marginLeft:"1rem", marginRight:"1rem"}}> 
                {!CourseDone && !loading && <IconButton
                    onClick={() => setActiveContent(1)}
                    style={{ padding: "0.5rem", height: "100%", width: editing && "100%", backgroundColor: "#F7F7F7", borderRadius: "calc(.25rem * var(--br-scale))" }}
                    icon2={"plus"}
                />}
                {!CourseDone && !loading && (
                    <ModalButton
                        title={courseData?.published? (navigationContext.sidebar.userId === "@me" || navigationContext.sidebar.userId === 0 ? "Start mijn cursus" : "Start cursus"): `Cursus publiceren`}
                        onClick={courseData?.published ? startCourse : publishLesson}
                        style={{width: "100%"}}
                    />
                )}
                {CourseDone && !loading && (
                    <StandardButton className={"center"} style={{ width: "100%", marginLeft: 0, }} backgroundColor={"primary-500"} textColor={"grey-100"} title={"Bekijk score"} onClick={() => setScoreModalVisible(true)} />
                )}
            </HorizontalLayout>
        </>
    );
};


const EditCourseContent = ({aiReload, handleAiGenerate,aiLoading, course , setCourse, handleEditCourse, dismiss}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth < 768;
    useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
  return (
    <>
      <VerticalLayout style={{ borderRadius: "0.5rem", backgroundColor: "var(--white)", width:"auto", minHeight: isMobile ? "calc(36rem)" : "" }}>
        <TitleAtom className="title-atom standard-margin" title={"Cursus bewerken"} />
        <VerticalLayout style={{margin: "0 1rem .75rem 1rem", width: "auto", }} >
            <InputForm
                title={"Titel"}
                placeholder={"Titel"}
                value={course.title}
                typeInput={(newValue) => setCourse({ ...course, title: newValue })}
            />
            <TextAreaForm
                aiReload={aiReload}
                handleAiGenerate={handleAiGenerate}
                aiLoading={aiLoading}
                AI={true}
                size={"large"}
                title={"Beschrijving"}
                placeholder={"Beschrijving"}
                value={`${course.description}\n\n${course.extra_description}`}
                typeInput={(newValue) => {
                    const [first, second] = newValue.split(/\n\n/);
                    setCourse({ ...course, description: first || "", extra_description: second || "" });
                }}
            />
        </VerticalLayout>
        <HorizontalLayout style={{gap: "1rem", marginTop: "auto", width: "auto", marginBottom:"1rem", marginLeft:"1rem", marginRight:"1rem"}}>
            <IconButton  style={{ padding: "0.5rem", height: "100%", backgroundColor: "#F7F7F7", borderRadius: "calc(.25rem * var(--br-scale))" }} icon2={"arrow-left"} onClick={dismiss}/>
            <ModalButton style={{ width: "100%", }} onClick={handleEditCourse} title="Opslaan" />
        </HorizontalLayout>
      </VerticalLayout>
    </>
  );
};
